exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-shape-outer-color-overall, .background-shape-outer-color-overall::before {\n    background-color: #c9c7c3;\n}\n\n.background-shape-outer {\n    padding: 0px 0px 5px 0px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/overall/overall.component.css
// module id = ../../../../../src/app/core-modules/statistics/overall/overall.component.css
// module chunks = main